import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './auth-context';

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);

  // Erro explícito em vez de valor padrão silencioso: um `user: null` devolvido fora
  // do provider faria a guarda de rota redirecionar para o login sem motivo, e o
  // defeito apareceria como comportamento estranho em vez de erro.
  if (!context) {
    throw new Error('useAuth precisa estar dentro de <AuthProvider>.');
  }

  return context;
}
